(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/react/shared-components/dialogs.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/react/shared-components/dialogs.js');

'use strict';

const {
  dialog: dialogComp
} = svs.components;
const {
  route
} = svs.playerLogin.constants;

const handleShowLoginErrorText = errorMessage => {
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.TUR,
    icon: 'exclamation-sign',
    area: dialogComp.area.POPUP,
    type: dialogComp.type.ERROR,
    title: 'Misslyckad inloggning',
    message: [{
      type: dialogComp.message.TEXT,
      text: errorMessage,
      align: dialogComp.message.align.CENTER
    }],
    actions: [{
      title: 'Ok',
      callback: () => {
        dialog.close();
      }
    }]
  });
  dialogComp.api.add(dialog);
};
const handleShowError = function () {
  let callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : () => {};
  svs.core.flash(svs.ui.dialog.type.ERROR, {
    title: 'Misslyckad inloggning',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Det går inte att logga in just nu, var vänlig försök igen lite senare.',
      align: svs.ui.dialog.message.align.CENTER
    }],
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.ERROR,
    branding: svs.ui.dialog.branding.TUR,
    icon: 'exclamation-sign'
  }, () => {
    callback();
  });
};
const handleShowErrorNoFlash = () => new Promise(resolve => {
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.TUR,
    icon: 'exclamation-sign',
    area: dialogComp.area.POPUP,
    type: dialogComp.type.ERROR,
    title: 'Misslyckad inloggning',
    message: [{
      type: dialogComp.message.TEXT,
      text: 'Det går inte att logga in just nu, var vänlig försök igen lite senare.',
      align: dialogComp.message.align.CENTER
    }],
    actions: [{
      title: 'Ok',
      callback: () => {
        dialog.close();
        resolve();
      }
    }]
  });
  dialogComp.api.add(dialog);
});
const handleShowChangeToBankId = history => {
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.TUR,
    icon: 'help',
    area: dialogComp.area.POPUP,
    title: 'Vill du logga in med BankId istället',
    actions: [{
      title: 'Nej tack',
      callback: () => {
        history.push(route.LOGIN_FREJAEID_ROUTE);
        dialog.close();
      }
    }, {
      title: 'Ja det vill jag',
      callback: () => {
        history.push(route.LOGIN_BANKID_ROUTE);
        dialog.close();
      }
    }]
  });
  dialogComp.api.add(dialog);
};
const handleShowFrejaEidError = history => {
  const dialog = new dialogComp.Confirm({
    branding: dialogComp.branding.TUR,
    icon: 'exclamation-sign',
    area: dialogComp.area.POPUP,
    type: dialogComp.type.ERROR,
    title: 'Misslyckad inloggning',
    message: [{
      type: dialogComp.message.TEXT,
      text: 'Ett fel har upstått när du försökte logga in.',
      align: dialogComp.message.align.CENTER
    }],
    actions: [{
      title: 'Ok',
      callback: () => {
        handleShowChangeToBankId(history);
        dialog.close();
      }
    }]
  });
  dialogComp.api.add(dialog);
};
svs.playerLogin.sharedComponents.Dialogs = {
  handleShowLoginErrorText,
  handleShowError,
  handleShowFrejaEidError,
  handleShowErrorNoFlash
};

 })(window);